import * as api from '../../services/role'

export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_ROLE = 'FETCH_ROLE';


export const fetchRole = (id) => ({
    type: FETCH_ROLE,
    payload: {
        promise: api.findRole({id: id})
    }
});


export const fetchRoles = (params, sort, extra) => {
    return {
        type: FETCH_ROLES,
        payload: {
            promise: api.findRoles(Object.assign({}, params)),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/role.js